export default {  
    methods: {
        getAuthorization(applicationOption, authField) {
            this.$axios.post("ares/json/ares/syst/authorization/getAuthorization.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getAuthorization"
                },
                getAuthorization: {
                    option: applicationOption,
                }
            }).then(res => {
                if (res.data.header.result == "error") {
                    console.log(res.data.error);
                    // Any error: Not Authorized 
                    this[authField] = false;
                } else {
                    this[authField] = res.data.getAuthorization;
                }
            })
        },
    },
}